<template>
  <div>
    <v-container>
      <v-card class="selectTitle" flat>
        <v-row>
          <v-col cols="4">
            <div class="buken">物件名</div>
            <ryou-select class="bukens" outlined v-model="buildSelect" :value="buildSelect" :items="buildItems"
              :itemText="'building_name'" :itemValue="'building_id'">
            </ryou-select>
          </v-col>
          <v-col cols="4">
            <div class="copy">コピー先物件名</div>
            <ryou-select class="copys" outlined v-model="cpBuildSelect" :value="cpBuildSelect" :items="cpBuildItems"
              :itemText="'building_name'" :itemValue="'building_id'">
            </ryou-select>
          </v-col>
          <v-col cols="2" />
          <v-col cols="2">
            <ryou-black-btn :label="'コピー設定'" :handlerClick="handleBillingCopy" :iconCls="'mdi-pencil'">
            </ryou-black-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <hr />
    <v-container class="bottom">
      <v-row>
        <v-col>
          <Billing class="item" ref="electricalBilling" :componentUrl="'electrical'" :content="content">
          </Billing>
        </v-col>
        <v-col>
          <Billing class="item" ref="gasBilling" :componentUrl="'gas'" :content="content2">
          </Billing>
        </v-col>
        <v-col>
          <Billing class="item" ref="waterBilling" :componentUrl="'water'" :content="content3">
          </Billing>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Billing from "./modules/Billing";
  import RyouSelect from "@/components/formInput/RyouSelect.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  export default {
    components: {
      Billing,
      RyouSelect,
      RyouBlackBtn,
    },
    data() {
      return {
        businessKeys: ["building_id"],
        buildSelect: "",
        cpBuildSelect: "",
        buildItems: [],
        cpBuildItems: [],
        content: {
          title: "電気料金",
          valu1: "電気基本料金",
          monery1: "電気基準金額１",
          monery2: "電気基準金額２",
          monery3: "電気基準金額３",

          disRadio: null,
        },
        content2: {
          title: "ガス料金",
          valu1: "ガス基本料金",
          monery1: "ガス基準金額１",
          monery2: "ガス基準金額２",
          monery3: "ガス基準金額３",

        },
        content3: {
          title: "水道料金",
          valu1: "水道基本料金",
          monery1: "水道基準金額１",
          monery2: "水道基準金額２",
          monery3: "水道基準金額３",

        },
      };
    },
    created() {
      this.initData();
    },

    watch: {
      buildSelect(value) {
        if (value != null && value != "") {
          this.$refs.electricalBilling.BillingValueSet(value);
          this.$refs.gasBilling.BillingValueSet(value);
          this.$refs.waterBilling.BillingValueSet(value);
        }
      }
    },
    methods: {
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        };
            this.getRequest("/masterRoom/buildingGet", params, this.$store.getters.getUserToken).then((data) => {

          if (data.success) {
            this.buildItems = data.result; //物件名
            this.cpBuildItems = data.result; //物件名
          }
        });
      },
      handleBillingCopy() {
        let params = {
          building_id_from: this.buildSelect,
          building_id_to: this.cpBuildSelect,
          userId: this.$store.getters.getUserId,
        };
          this.getRequest("/masterBilling/copyBillingGet", params, this.$store.getters.getUserToken)
      },
    },
  };
</script>

<style scoped>
  .selectTitle {
    border-radius: 0%;
    margin: 20px;
  }

  .bottom {
    padding-top: 30px;
  }

  .item {
    margin-right: 10px;
    margin-bottom: 50px;
  }
</style>